import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { FireIcon } from '@sorare/core/src/atoms/icons/Fire';
import { isType } from '@sorare/core/src/lib/gql';
import type { unitMapping } from '@sorare/core/src/lib/style';

import type { TaskIcon_task } from './__generated__/index.graphql.ts';

const Hexagon = styled.div`
  aspect-ratio: 1;
  position: relative;
  display: flex;
  z-index: 0;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
    z-index: -1;
    border: 1px solid var(--c-rewards-orange);
    background-color: #210700;
  }
`;

export const TaskIcon = ({
  task,
  size,
}: {
  task: TaskIcon_task;
  size?: keyof typeof unitMapping;
}) => {
  if (isType(task, 'ThresholdsStreakTask')) {
    return (
      <Hexagon>
        <FireIcon size={size} />
      </Hexagon>
    );
  }
  return null;
};

TaskIcon.fragments = {
  task: gql`
    fragment TaskIcon_task on TaskInterface {
      id
    }
  ` as TypedDocumentNode<TaskIcon_task>,
};
